import React from "react";
import Calculator from "./calculator";
import { formatNumber } from "../../../../middleware/common-functions";
import { OrderType } from "../../../../models/order_model";
import { CalculatorItem } from "../../../../models/calculator_model";

type PayOutProps = {
  order: OrderType;
  addUp: any;
  calculator: CalculatorItem;
  payOutBack: any;
  payOrder: any;
  shake: boolean;
  setPaymentType: any;
  tip: number;
  onTipChange: (tipInput: string) => void;
  tipInput: string;
  tipFocused: boolean;
  setTipFocused: (focused: boolean) => void;
};

const PayOut: React.FC<PayOutProps> = ({
  order,
  addUp,
  calculator,
  payOutBack,
  payOrder,
  shake,
  setPaymentType,
  tip,
  onTipChange,
  tipInput,
  tipFocused,
  setTipFocused,
}) => (
  <div className="container-fluid py-2">
    <div className="row charge_div">
      <div className="col p-1">
        <div className="d-flex align-items-center justify-content-center">
          <h5 className="fa-2x text_blue m-0">
            Total: <b>${formatNumber(order.total)}</b>
          </h5>
          <h5 className="m-0 ml-3">Movimientos</h5>
        </div>

        <div className="d-flex align-items-center justify-content-center my-2">
          <label className="m-0 mr-2"><b>Propina:</b></label>
          <input
            type="text"
            className="form-control form-control-sm"
            style={{ maxWidth: 120 }}
            placeholder="ej: 50 o 15%"
            value={tipInput}
            onChange={(e) => onTipChange(e.target.value)}
            onFocus={() => setTipFocused(true)}
            onKeyUp={(e) => e.stopPropagation()}
          />
          {tip > 0 && (
            <span className="ml-2 text-success">
              <b>${formatNumber(tip)}</b>
            </span>
          )}
        </div>
        {tip > 0 && (
          <h6 className="text-center text-success m-0">
            Gran Total: <b>${formatNumber(order.total + tip)}</b>
          </h6>
        )}

        <hr className="my-1" />

        <h6 className="text-center mb-0">Monto</h6>
        <h5 className="my-1 fa-2x text-center">
          $<span className="cash">{calculator.amount || 0}</span>
        </h5>
        {calculator.cash_diff ? (
          <h6
            className={`text-center ${
              calculator.cash_diff > 0 ? "text-muted" : "text-success"
            } ${shake ? "shake_anim" : ""}`}
          >
            <span id="cash_left_txt">
              {calculator.cash_diff > 0 ? "Restante" : "Cambio"}
            </span>
            : $
            <span className="cash_left">
              {formatNumber(
                calculator.cash_diff > 0
                  ? calculator.cash_diff
                  : -calculator.cash_diff,
              )}
            </span>
          </h6>
        ) : null}
        <div className="alert alert-warning text-center d-none" role="alert">
          <h4 className="alert-heading">
            <i className="fas fa-exclamation"></i> Efectivo Insuficiente!
          </h4>
        </div>
      </div>
    </div>
    <Calculator
      addUp={addUp}
      payOutBack={payOutBack}
      payOrder={payOrder}
      type={order.payment_type}
      card_type={order.card_type}
      setPaymentType={setPaymentType}
      ready={
        calculator.amount
          ? (!calculator.cash_diff && calculator.cash_diff !== 0) ||
            calculator.cash_diff > 0
            ? false
            : true
          : true
      }
      charge_total={calculator.amount ? false : true}
      tipFocused={tipFocused}
      setTipFocused={setTipFocused}
    />
  </div>
);

export default PayOut;
